/**
 * Check if a date is at weekend
 */
export default function isWeekend(dt) {
  const dayOfWeek = dt.getDay();

  // 6 = Saturday, 0 = Sunday
  return dayOfWeek === 6 || dayOfWeek === 0;
}
